import React, { useEffect, useRef, useState } from "react";
import { ElevProfileVM } from "./ElevProfileVM";

const ElevProfileWidget = ({ activeWidget,view }) => {
  const [visible, setVisible] = useState(false);
  const elevProfileDiv = useRef(null);

  const elevationProfile=useRef(null);

  useEffect(() => {
    if (activeWidget === 'Elevation Profile') {
      setVisible(true);
    } else {
      setVisible(false);
    }
  }, [activeWidget]); 
  
  useEffect(() => {
    if (elevProfileDiv.current) {
      ElevProfileVM(elevProfileDiv.current, view).then((widget) => {
        elevationProfile.current = widget;
      });

      return () => {
        elevationProfile.current.destroy();
      };
    }
  }, []);
  let style = { display: "initial" };
  if (visible) {
    style.display = "block";
  } else {
    style.display = "none";
  }
  return <div ref={elevProfileDiv} style={style}></div>;
};

export default ElevProfileWidget;
